var _g, _g2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -638.378,
    y: -54.877,
    display: "inline",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    width: 1243.174,
    height: 368.982
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.001,43.086c6.727,0,12.198-5.473,12.198-12.199s-5.472-12.199-12.198-12.199S37.801,24.16,37.801,30.887   S43.274,43.086,50.001,43.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.271,43.595c-3.005,2.668-6.946,4.304-11.271,4.304c-4.326,0-8.267-1.636-11.272-4.304   c-4.636,1.673-7.966,6.105-7.966,11.311v26.407h38.474V54.906C69.237,49.7,65.908,45.268,61.271,43.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.269,43.495c5.887,0,10.685-4.707,10.855-10.554c-0.082-0.675-0.137-1.358-0.137-2.055c0-0.001,0-0.001,0-0.002   c-0.837-5.168-5.318-9.131-10.719-9.131c-5.995,0-10.871,4.877-10.871,10.871C11.398,38.619,16.275,43.495,22.269,43.495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.291,44.717C8.008,46.561,5,50.821,5,55.772V75.84h20.95V54.906c0-2.744,0.673-5.328,1.841-7.619   c-1.721,0.65-3.576,1.023-5.522,1.023C18.482,48.309,15.004,46.959,12.291,44.717z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.876,32.936c0.167,5.85,4.966,10.56,10.854,10.56c5.995,0,10.871-4.877,10.871-10.871   c0-5.994-4.877-10.871-10.871-10.871c-5.403,0-9.886,3.968-10.719,9.141C67.012,31.586,66.958,32.265,66.876,32.936z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.709,44.717c-2.713,2.243-6.191,3.592-9.978,3.592c-1.945,0-3.801-0.373-5.522-1.023   c1.168,2.291,1.841,4.876,1.841,7.62V75.84H95V55.772C95,50.821,91.992,46.561,87.709,44.717z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c19aeddc02e91a99208f4512680fcbc5.svg";
export { ForwardRef as ReactComponent };